import { render, staticRenderFns } from "./platform.vue?vue&type=template&id=6316bff4&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./platform.vue?vue&type=script&lang=js&"
export * from "./platform.vue?vue&type=script&lang=js&"
import style0 from "./platform.vue?vue&type=style&index=0&id=6316bff4&prod&scoped=true&lang=css&"
import style1 from "./platform.vue?vue&type=style&index=1&id=6316bff4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6316bff4",
  null
  
)

export default component.exports